"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shallowCompare = _interopRequireDefault(require("./shallow-compare"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var renderGuard = function renderGuard(data) {
  var _dispatchPayload$opti;

  var dispatchValue = data.dispatchValue,
      currentState = data.currentState,
      dispatchPayload = data.dispatchPayload;

  if (((_dispatchPayload$opti = dispatchPayload.options) === null || _dispatchPayload$opti === void 0 ? void 0 : _dispatchPayload$opti.renderGuard) !== false) {
    if (dispatchValue !== currentState) {
      var isObject = dispatchValue && _typeof(dispatchValue) === 'object' && currentState && _typeof(currentState) === 'object';

      if (isObject) {
        if (Array.isArray(dispatchValue)) {
          if (dispatchValue.length === 0 && currentState.length === 0) {
            return false;
          }

          return true;
        }

        if (!(0, _shallowCompare["default"])(dispatchValue, currentState)) {
          return false;
        }

        ;
        return true;
      }

      return true;
    }

    return false;
  }

  return true;
};

var _default = renderGuard;
exports["default"] = _default;
module.exports = exports.default;